import React from 'react';
import { DocumentFile } from './shared/types';
import FlairIcon from '../../../../atomic/atoms/FlairIcon';

type Props = {
  file: DocumentFile;
};

export const DownloadLink: React.FC<React.PropsWithChildren<Props>> = ({
  file,
}) => {
  return (
    <a href={file.downloadPublicUrl} target="_blank" rel="noopener noreferrer">
      <FlairIcon icon="document-outline" className="me-3" />
      {file.fileName}
    </a>
  );
};
